<template>
  <b-card>
    <payment-method-edit-account
      v-if="loader === false"
      class="mt-2 pt-75"
      :user-data="userData"
    />
  </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import { ref/* , onUnmounted */ } from '@vue/composition-api'
import store from '@/store'
import router from '@/router'
import PaymentMethodEditAccount from './PaymentMethodEditAccount.vue'
import paymentMethodStoreModule from '../paymentMethodStoreModule'

export default {
  components: {
    BCard,
    PaymentMethodEditAccount,
  },
  data() {
    return {
      loader: true,
      userData: ref(null),
    }
  },
  created() {
    // const userData = ref(null)
    const PAYMENT_METHOD_APP_STORE_MODULE_NAME = 'app-payment-method'

    // Register module
    if (!store.hasModule(PAYMENT_METHOD_APP_STORE_MODULE_NAME)) store.registerModule(PAYMENT_METHOD_APP_STORE_MODULE_NAME, paymentMethodStoreModule)

    store.dispatch('app-payment-method/getPaymentMethod', { id: router.currentRoute.params.id })
      .then(response => {
        this.userData = response.data.data
        this.loader = false
        console.log('then', this.userData)
      })
      .catch(error => {
        if (error.response.status === 404) {
          this.userData = undefined
        }
      })
  },
}
</script>

<style>

</style>
